
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BankTransApi } from '../api/bankTransaction.api';
import { switchMap, map } from 'rxjs/operators';
import { BankTransData, BankTrans } from '../../../interfaces/masters/bankTransaction';

@Injectable()
export class BankTransService extends BankTransData {

  constructor(private api: BankTransApi) {
    super();
  }


  list(url: string): Observable<BankTrans[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<BankTrans>{
      return this.api.getById(url);
  }

  create(url: string, data:BankTrans): Observable<BankTrans> {
    return this.api.add(url,data);
  }

  update(url: string, data:BankTrans): Observable<BankTrans> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

   searchList(url: string,data:any): Observable<any> {
       
        return this.api.searchList(url,data);
      }
}
